import { render, staticRenderFns } from "./ptcats.vue?vue&type=template&id=87c14462&scoped=true&"
import script from "./ptcats.vue?vue&type=script&lang=js&"
export * from "./ptcats.vue?vue&type=script&lang=js&"
import style0 from "./ptcats.vue?vue&type=style&index=0&id=87c14462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c14462",
  null
  
)

export default component.exports